import { SystemPermissionDef } from '@juvare/contact-management/backend/features/permissions/shared';

export const logiReportsOrgPermissions = {
    'run-reports': {
        group: 'Logi reports',
        label: 'View Logi reports',
    },
} as const satisfies SystemPermissionDef;
